<template>
  <div v-if="status" class="i-pill i-text-subheading-3 i-ml-2">
    <span v-if="status === options.REQUIRES_REVIEW" class="warning"
      >Requires review</span
    >
    <span v-else-if="status === options.AUTO_ACCEPTED" class="outline"
      >Auto-accepted</span
    >
    <span v-else-if="status === options.ACCEPTED" class="success"
      >Accepted</span
    >
    <span v-else-if="status === options.REJECTED" class="error">Rejected</span>
  </div>
</template>
<script>
import * as documentStatusOptions from '@/constants/documentStatus';

export default {
  name: 'DocumentStatus',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: documentStatusOptions,
    };
  },
};
</script>
